{
    "dottnet.home.change-theme": "Cambia tema",
    "dottnet.home.check-blogs": "or check blogs home",
    "dottnet.home.contributors.description1": "Want to start contributing to open source with Angular?",
    "dottnet.home.contributors.description2": "Leave your mark and join the growing team of contributors!",
    "dottnet.home.contributors.description3": "Get started by having a look on ",
    "dottnet.home.contributors.description4": " and ",
    "dottnet.home.contributors.guide": "Contributor guide",
    "dottnet.home.contributors.issues": "open issues",
    "dottnet.home.contributors.title": "Contributors",
    "dottnet.home.get-notified.description": "a Twitter bot that helps you to stay up to date with releases of popular frontend frameworks & libraries!",
    "dottnet.home.get-notified.follow": "Follow",
    "dottnet.home.get-notified.title": "Get notified home new releases",
    "dottnet.home.get-started": "Get started",
    "dottnet.home.follow-us": "Seguici su",
    "dottnet.features.angular": "Modern powerful framework",
    "dottnet.features.angular-cli": "A command line interface for Angular",
    "dottnet.features.angular-material": "Material design component library",
    "dottnet.features.bootstrap": "Responsive layout from battle tested, world most famous UI library",
    "dottnet.features.cypress": "Cypress is a next generation front end testing tool built for the modern web.",
    "dottnet.features.documentation": "Docs",
    "dottnet.features.fontawesome": "Easy to use vector icons and social logos",
    "dottnet.features.guide": "Guide",
    "dottnet.features.lazyloading.description": "Faster startup time with lazy loaded feature modules",
    "dottnet.features.lazyloading.title": "Lazy loading",
    "dottnet.features.ngrx": "One way data flow powered by RxJS Observables",
    "dottnet.features.ngxtranslate": "An internationalization library for Angular",
    "dottnet.features.rxjs": "Reactive programming with async collections using Observables",
    "dottnet.features.themes.description": "Flexible theming support for provided and custom components",
    "dottnet.features.themes.title": "Themes",
    "dottnet.features.title": "Features",
    "dottnet.features.typescript": "Superior developer experience, code completion, refactoring and less bugs",
    "dottnet.features.eslint": "ESLint is for identifying problematic patterns found in JavaScript and Typescript code",
    "dottnet.footer.changelog": "Show changelog",
    "dottnet.header.github": "Project Github Repository",
    "dottnet.menu.home": "Home",
    "dottnet.menu.content": "Contenuti",
    "dottnet.menu.news": "News",
    "dottnet.menu.document": "Documenti",
    "dottnet.menu.dossier": "Dossier",
    "dottnet.menu.video": "Video",
    "dottnet.menu.canale": "Canali",
    "dottnet.menu.minisito": "Minisiti",
    "dottnet.menu.offline": "Offline",
    "dottnet.menu.blog": "Blog",
    "dottnet.menu.professional": "Professionali - Societari",
    "dottnet.menu.patient": "Associazione pazienti",
    "dottnet.menu.rarediseasepatient": "Associazione pazienti malattie rare",
    "dottnet.menu.extra": "eXtra",
    "dottnet.menu.discoverextra": "Scopri eXtra",
    "dottnet.menu.myextra": "Il mio eXtra",
    "dottnet.menu.mycourses": "I miei corsi",
    "dottnet.menu.articleextra": "Articoli eXtra",
    "dottnet.menu.privacybox": "Privacy box",
    "dottnet.menu.iframe": "Iframe",
    "dottnet.menu.toolbox": "Toolbox",
    "dottnet.menu.fad": "Fad",
    "dottnet.menu.pec": "Pec",
    "dottnet.menu.mail": "Mail",
    "dottnet.menu.list": "Lista",
    "dottnet.menu.examples": "Esempi",
    "dottnet.menu.features": "Features",
    "dottnet.menu.accedi": "Accedi a DottNet",
    "dottnet.menu.login": "Accedi",
    "dottnet.menu.signup": "Registrati",
    "dottnet.menu.logout": "Logout",
    "dottnet.menu.settings": "Preferenze",
    "dottnet.menu.profile": "Profilo",
    "dottnet.menu.managelog": "Gestisci log",
    "dottnet.menu.schedario": "Schedario",
    "dottnet.menu.ricerca": "Cosa stai cercando?",
    "dottnet.menu.ecm": "ECM",
    "dottnet.settings.animations.elements": "Navigation page elements slide up",
    "dottnet.settings.animations.page": "Navigation whole page transition",
    "dottnet.settings.animations.title": "Animazioni",
    "dottnet.settings.general.language.de": "German",
    "dottnet.settings.general.language.en": "English",
    "dottnet.settings.general.language.es": "Spanish",
    "dottnet.settings.general.language.fr": "French",
    "dottnet.settings.general.language.he": "Hebrew",
    "dottnet.settings.general.language.pt-br": "Portuguese",
    "dottnet.settings.general.language.sk": "Slovak",
    "dottnet.settings.general.language.zh-cn": "Simple Chinese",
    "dottnet.settings.general.placeholder": "Lingua",
    "dottnet.settings.general.title": "General",
    "dottnet.settings.themes.blue": "Blue",
    "dottnet.settings.themes.dark": "Dark",
    "dottnet.settings.themes.light": "Light",
    "dottnet.settings.themes.nature": "Nature",
    "dottnet.settings.themes.night-mode": "Auto night mode (from 21:00 to 7:00)",
    "dottnet.settings.themes.placeholder": "Color Theme",
    "dottnet.settings.themes.saneago": "",
    "dottnet.settings.themes.sticky-header": "Sticky header",
    "dottnet.settings.themes.title": "Temi",
    "dottnet.settings.title": "Preferenze",
    "dottnet.title.long": "DottNet",
    "dottnet.title.short": "DottNet",
    "dottnet.login.required": "Il campo non può essere vuoto",
    "dottnet.login.username": "Email",
    "dottnet.login.password": "Password",
    "dottnet.login.rememberme": "Ricordami",
    "dottnet.login.submit": "Accedi",
    "dottnet.login.error": "C'è stato un errore:",
    "dottnet.login.email": "Inserisci l'email:",
    "dottnet.login.pwd": "Recupera",
    "dottnet.login.pwdforbidden": "Recupera password",
    "dottnet.login.register": "Registrati",
    "dottnet.schedario.medici": "Medici",
    "dottnet.schedario.cercamedici": "Cerca Medico",
    "dottnet.schedario.carica": "Carica Schedario",
    "dottnet.logs.searchtext": "cerca nei log",
    "dottnet.logs.delete": "DBLog svuotato. Cancellati {{value}} records",
    "dottnet.progettiazioni.selezionaprogettoazione": "Seleziona Progetto e azione",
    "dottnet.progettiazioni.selezionaprogetto": "Seleziona Progetto",
    "dottnet.progettiazioni.selezionaazione": "Seleziona Azione",
    "dottnet.shared.cerca": "Cerca...",
    "dottnet.shared.generic_select": "Seleziona un'opzione",
    "dottnet.shared.generic_placeholder": "Scrivi...",
    "dottnet.shared.nessunrisultato": "Nessun risultato",
    "dottnet.shared.category": "Categoria",
    "dottnet.shared.specialty": "Specializzazione",
    "dottnet.schedario.visite_ciclo": "Visite per ciclo",
    "dottnet.schedario.in_schedario": "In Schedario",
    "dottnet.schedario.personalizza_visite": "Visite",
    "dottnet.schedario.minimo_visite": "Da",
    "dottnet.schedario.massimo_visite": "A",
    "dottnet.operatori.selezionaoperatore": "Operatore",
    "dottnet.specializzazioni.selezionaspecializzazione": "Specializzazione",
    "dottnet.situazione-cliente": "Situazione Cliente",
    "dottnet.situazione-cliente.short": "Sit. Cliente",
    "dottnet.domande-risposte": "Domande e risposte",
    "dottnet.domande-risposte.select_istanza": "Seleziona un istanza",
    "dottnet.domande-risposte.select_date": "Seleziona una data",
    "dottnet.domande-risposte.short": "Dom/Ris",
    "dottnet.dottnet.last-login": "Ultima Login",
    "dottnet.dottnet.username": "Username",
    "dottnet.dottnet.password": "Password",
    "dottnet.dottnet.premium": "Premium",
    "dottnet.progettimail.selectmail": "Mail",
    "dottnet.shared.required": "Campo obbligatorio",
    "dottnet.shared.research": "Risultati di ricerca",
    "dottnet.shared.emptyresults": "Non sono presenti risultati per questa ricerca",
    "dottnet.filtri.selectfiltro": "Filtro",
    "dottnet.shared.search": "Carica",
    "dottnet.shared.id_anagrafica": "Id_Anagrafica",
    "dottnet.shared.nome": "Nome",
    "dottnet.shared.cognome": "Cognome",
    "dottnet.shared.categoria": "Categoria",
    "dottnet.shared.listapersonale": "Lista Personale",
    "dottnet.shared.schedario": "Schedario",
    "dottnet.shared.ricercasemplice": "Ricerca semplice",
    "dottnet.categorie.selezionacategoria": "Categoria",
    "dottnet.shared.provincia": "Provincia",
    "dottnet.shared.localita": "Comune",
    "dottnet.shared.indirizzo": "Indirizzo",
    "dottnet.shared.email": "Email",
    "dottnet.shared.cf": "Codice Fiscale",
    "dottnet.shared.recapito": "Recapito Telefonico",
    "dottnet.shared.ricercanagrafica": "Ricerca Id_Anagrafica",
    "dottnet.shared.ricercavanzata": "Avanzate",
    "dottnet.shared.entita": "Entita",
    "dottnet.shared.assegnati": "Assegnati",
    "dottnet.shared.reclutati": "Reclutati",
    "dottnet.shared.searchselect": "Selezionare un metodo di ricerca",
    "dottnet.shared.altro": "Altro",
    "dottnet.shared.assistenza": "Qualcosa è andato storto. Contattare l'assistenza.",
    "dottnet.shared.attenzione": "Attenzione",
    "dottnet.shared.moreContent": "Mostra Altri",
    "dottnet.wall.title": "Aggiorna Dati",
    "dottnet.wall.dati_professionali": "Dati professionali",
    "dottnet.wall.consensi": "Consensi *",
    "dottnet.wall.anagrafica": "Dati Personali",
    "dottnet.wall.accept": "Acconsento",
    "dottnet.wall.notaccept": "Non acconsento",
    "dottnet.wall.conditions": "Le nostre condizioni di utilizzo sono",
    "dottnet.wall.datainformative": "La nostra Informativa sull'utilizzo dei dati (compresa la sezione dedicata all'uso dei cookie) è",
    "dottnet.wall.here": "qui",
    "dottnet.wall.codicefiscale": "Codice fiscale",
    "dottnet.wall.codiceBelfiore": "Codice Belfiore",
    "dottnet.wall.dataNascita": "Data di nascita",
    "dottnet.wall.nome": "Nome",
    "dottnet.wall.cognome": "Cognome",
    "dottnet.wall.fotoUtente": "Foto utente",
    "dottnet.wall.iconaUtente": "Icona utente",
    "dottnet.wall.sesso": "Sesso",
    "dottnet.wall.provincia": "Provincia",
    "dottnet.wall.numeroIscrizioneAlbo": "Iscrizione all'albo",
    "dottnet.wall.cap": "CAP",
    "dottnet.wall.anc": "Anc",
    "dottnet.wall.completaProfilo": "Completa Profilo",
    "dottnet.wall.bodyConsent": "Gentile utente, abbiamo apportato delle modifiche alla nostra informativa privacy per garantirle una maggiore trasparenza e protezione dei suoi dati personali. La invitiamo pertanto a prendere visione della nostra nuova <a target='_blank' href='/privacy'>informativa</a> così da aggiornare i consensi.",
    "dottnet.wall.bodyGeneral": "Prima di proseguire, consideri la compilazione dei seguenti campi",
    "dottnet.specialty.selezionaspecialty": "Seleziona specializzazione",
    "dottnet.category.selezionacategory": "Seleziona categoria",
    "dottnet.province.selezionaprovince": "Seleziona provincia",
    "dottnet.pagina.piuletti": "Più letti",
    "dottnet.pagina.ultimivideo": "Ultimi video",
    "dottnet.article.related": "I Correlati",
    "dottnet.article.interested": "Ti potrebbero interessare",
    "dottnet.article.notmissed": "Da non perdere",
    "dottnet.article.latest": "Ultime News",
    "dottnet.permessi.login": "Gentile utente il contenuto è riservato, si prega di effettuare la login",
    "dottnet.permessi.unauthorizedTitle": "Non Autorizzato",
    "dottnet.permessi.unauthorized": "Gentile utente non è autorizzato a visualizzare il contenuto",
    "dottnet.permessi.notFoundTitle": "Contenuto non trovato",
    "dottnet.permessi.activateMail": "Attivazione Account",
    "dottnet.permessi.notFound": "Gentile utente il contenuto che sta cercando non esiste",
    "dottnet.permessi.sessionExpiredTitle": "Sessione Scaduta",
    "dottnet.permessi.sessionExpired": "Gentile utente, la sua sessione è scaduta. La preghiamo di effettuare nuovamente il login",
    "dottnet.permessi.genericPermission": "Gentile utente, per poter proseguire è necessario autenticarsi",
    "dottnet.permessi.commentPermission": "Gentile utente, per poter commentare è necessario autenticarsi",
    "dottnet.permessi.attenzione": "Attenzione",
    "dottnet.button.save": "Salva",
    "dottnet.button.delete": "Cancella",
    "dottnet.button.send": "Invia",
    "dottnet.button.changePassword": "Cambia password",
    "dottnet.button.consents.fine": "Ho capito",
    "dottnet.button.consents.confirm": "Conferma",
    "dottnet.button.unsubscribe": "Segui già",
    "dottnet.button.subscribe": "Segui",
    "dottnet.label.ecmInfos": "Dati Ecm",
    "dottnet.label.professionalInfos": "Dati Professionali",
    "dottnet.label.yes": "Sì",
    "dottnet.label.no": "No",
    "dottnet.label.sponsor": "Indicare società di riferimento",
    "dottnet.label.ecm": "Ecm. Clicchi la spunta se pensa di voler partecipare a qualche corso Ecm",
    "dottnet.label.name": "Nome",
    "dottnet.label.cellulare": "Cellulare",
    "dottnet.label.cap": "CAP",
    "dottnet.label.surname": "Cognome",
    "dottnet.label.email": "Email",
    "dottnet.label.password": "Password",
    "dottnet.label.codiceFiscale": "Codice fiscale",
    "dottnet.label.birthdate": "Data di nascita",
    "dottnet.label.bornAbroad": "Nato all'estero",
    "dottnet.label.birthplace": "Comune di nascita",
    "dottnet.label.professionplace": "Comune dove esercita",
    "dottnet.label.professionType": "Tipo di professione",
    "dottnet.label.agenasdisciplineType": "Disciplina",
    "dottnet.label.birthplace.question": "Nato all'estero?",
    "dottnet.label.gender": "Sesso",
    "dottnet.label.gender.M": "Uomo",
    "dottnet.label.gender.F": "Donna",
    "dottnet.label.category": "Categoria",
    "dottnet.label.specialty": "Specializzazione",
    "dottnet.label.registerNumber": "Numero di iscrizione all'albo",
    "dottnet.label.registerCity": "Provincia di iscrizione all'albo",
    "dottnet.label.consents.marketing": "Marketing",
    "dottnet.label.consents.marketingThirdParties": "Marketing Cessione Terzi",
    "dottnet.label.consents.profiling": "Profilazione",
    "dottnet.label.consents.profilingThirdParties": "Profilazione Cessione Terzi",

    "dottnet.title.comments": "Commenti",
    "dottnet.field.label.comments": "Cosa ne pensi?",
    "dottnet.field.label.comments.replying": "In risposta a",
    "dottnet.field.label.comments.showMore": "{{ numCommenti }} Risposte",
    "dottnet.field.label.comments.reply": "Rispondi",
    "dottnet.field.label.comments.attachment": "Nessun file caricato",
    "dottnet.field.error.comments": "Scrivi prima qualcosa",

    "dottnet.home.medlex": "Medlex",
    "dottnet.home.bulletin": "Bollettino Ministeriale",
    "dottnet.home.aifa": "Aifa Comunica",
    "dottnet.home.institutions": "Istituzioni",
    "dottnet.home.insights": "Approfondimenti",
    "dottnet.home.guideline": "Linee Guida",

    "dottnet.home.focusMedicina": "Focus in Medicina",
    "dottnet.home.focusVideo": "Video in Evidenza",

    "dottnet.label.oldPassword": "Vecchia Password",
    "dottnet.label.newPassword": "Nuova Password",
    "dottnet.label.confirmNewPassword": "Conferma Password",

    "dottnet.consents.accept": "Acconsento",
    "dottnet.consents.reject": "Non acconsento",
    "dottnet.consents.error": "Selezionare almeno una scelta",

    "dottnet.hint.email": "Contattare il nostro servizio clienti per modificare l'email",
    "dottnet.hint.password": "La password deve contenere almeno 8 caratteri tra cui una lettera minuscola, una maiuscola e un simbolo alfanumerico",
    "dottnet.field.error.cellulare": "Il valore immesso per il cellulare non è valido",
    "dottnet.field.error.numeric": "Il valore immesso non è numerico",
    "dottnet.field.error.required": "è un campo obbligatorio",
    "dottnet.field.error.email": "Digitare un'email valida. Esempio: prova@example.com",
    "dottnet.field.error.mailExistence": "La mail inserita è già presente nel nostro sistema. Hai dimenticato la password?",
    "dottnet.field.error.cfExistence": "Il codice fiscale inserito è già presente nel nostro sistema. Se credi sia un errore, contatta il nostro servizio clienti",
    "dottnet.field.error.cfLength": "Il codice fiscale deve essere lungo 16 caratteri",
    "dottnet.field.error.password": "Digitare una password valida. La password deve contenere almeno 8 caratteri tra cui una lettera minuscola, una maiuscola e un simbolo alfanumerico. Esempio: 9kY&epKG",
    "dottnet.field.error.invalidAge": "L'utente deve essere maggiorenne",
    "dottnet.field.error.registerForm": "Il modulo di iscrizione all'albo è obbligatorio",
    "dottnet.field.error.consentsForm": "Compilare il modulo consensi per intero",
    "dottnet.field.error.passwordMismatch": "Password e Conferma Password devono coincidere",
    "dottnet.field.error.emptyObject": "E' obbligatorio selezionare un valore. Iniziare a digitare.",

    "dottnet.dialog.consents.title": "Consensi",
    "dottnet.dialog.consents.marketing": "Solo previo Suo distinto ed esplicito consenso, al trattamento dei miei dati da parte del Titolare per le Finalità di Marketing di cui al punto 2.B) dell’Informativa (cioè per inviarmi comunicazioni e materiale pubblicitario o di vendita diretta di terzi soggetti, aventi contenuto commerciale, promozionale, pubblicitario e/o finalizzato all'informazione medico-scientifica; nonché per il compimento di ricerche di mercato, sondaggi d’opinione e analisi statistiche per finalità di marketing anche tramite raccolta del consenso per conto degli stessi. Il tutto può avvenire mediante l’uso di sistemi automatizzati di chiamata e/o email e/o fax e/o sms e/o mms e/o altri servizi di messaging e/o newsletter, e/o mediante modalità di marketing tradizionale come il telefono e/o posta cartacea)",
    "dottnet.dialog.consents.marketingThirdParties": "Solo previo Suo distinto ed esplicito consenso, alla comunicazione dei miei dati ai soggetti indicati all’art. 6 dell’Informativa, affinchè questi li trattino direttamente per le proprie Finalità di Marketing di cui al punto 2.D) dell’informativa  (ossia per inviarmi comunicazioni e materiale pubblicitario o di vendita diretta, aventi contenuto commerciale, promozionale, pubblicitario e/o finalizzato all'informazione medico-scientifica; nonché per il compimento di ricerche di mercato, sondaggi d’opinione e analisi statistiche per finalità di marketing. Il tutto mediante l’uso di sistemi automatizzati di chiamata e/o email e/o fax e/o sms e/o mms e/o altri servizi di messaging e/o newsletter, e/o mediante modalità di marketing tradizionale telefono e/o posta cartacea)",
    "dottnet.dialog.consents.profiling": "Solo previo Suo distinto ed esplicito consenso, al trattamento dei miei dati da parte del Titolare per le Finalità di Profilazione di cui al punto 2.C) dell’Informativa (cioè per analisi delle mie abitudini e scelte di consumo, di acquisto e professionali, svolte attraverso operazioni di segmentazione e tramite raccolta e analisi di sottogruppi di medici in base alle loro abitudini di navigazione, all’età ed alla specializzazione, volti unicamente ad orientare nel modo migliore la proposta di contenuti ed iniziative alle preferenze dell’utente, e ad evitare di proporgli argomenti non di suo interesse, ai fini dell’invio di comunicazioni e materiale pubblicitario o di vendita diretta su prodotti/servizi/iniziative e/o ricerche di mercato e/o sondaggi d’opinione e/o analisi statistiche di terzi soggetti, anche mediante l’uso di sistemi automatizzati di chiamata e/o email e/o fax e/o sms e/o mms e/o altri servizi di messaging e/o newsletter e/o telefono e/o posta cartacea)",
    "dottnet.dialog.consents.profilingThirdParties": "Solo previo Suo distinto ed esplicito consenso, alla comunicazione dei miei dati ai soggetti indicati all’art. 6 dell’Informativa, affinchè questi li trattino direttamente per le proprie Finalità di Profilazione di cui al punto 2.E) dell’informativa con annessa categoria e appartenenza ai“ gruppi” ai fini di svolgimento delle proprie attività di profilazione(finalizzate allo svolgimento da parte dei terzi di proprie analisi, invio di newsletter e sondaggi, comunicazioni di marketing diretto) anche mediante l’ uso di sistemi automatizzati di chiamata e / o email e / o fax e / o sms e / o mms e / o altri servizi di messaging e / o newsletter e / o telefono e / o posta cartacea)",

    "dottnet.notification.info": "Operazione avvenuta",
    "dottnet.notification.success": "Operazione eseguita con successo!",
    "dottnet.notification.error": "Operazione fallita! Riprovare",
    "dottnet.notification.ok": "OK",

    "dottnet.lista.leggi": "Leggi",
    "dottnet.lista.guarda": "Guarda",
    "dottnet.lista.apri": "Apri",

    "dottnet.confirmMail.text": "La preghiamo di attivare il Suo account cliccando sull'apposito link inviato alla Sua casella di posta elettronica indicata in fase di registrazione.\n\nNel caso quest'ultima non Le risultasse recapitata,\nLa preghiamo di controllare nella posta indesiderata oppure richiedere un nuovo link d'attivazione tramite il tasto presente in questa pagina",
    "dottnet.confirmMail.text.expired": "Siamo spiacenti ma il link d'attivazione in Suo possesso è scaduto. Abbiamo provveduto all'invio di una nuova mail d'attivazione al suo indirizzo di posta elettronica. Può richiedere l'invio di una nuova mail cliccando sul bottone dedicato.",
    "dottnet.confirmMail.button": "Invia Mail",
    "dottnet.confirmMail.returnToDrClick": "Ritorna a DrClick",

    "dottnet.text.welcome": "Benvenuto in DottNet!",
    "dottnet.text.sign": "Il Team DottNet",

    "dottnet.log.text": "Gentile Utente, questa pagina permette di ricevere assistenza dal nostro servizio clienti. Qualora ne avesse bisogno, può contattarci allo 800.014.863",
    "dottnet.log.empty": "Nessun log in memoria",
    "dottnet.log.records": "Sono presenti al momento ",
    "dottnet.log.delete": "Per cancellare tutti i log di Dottnet  ",
    "dottnet.log.send": "Per inviare i log di Dottnet all'assistenza ",
    "dottnet.log.reload": "Ricarica",

    "dottnet.message.changedpassword": "Password cambiata con successo!",
    "dottnet.message.retrievepassword": "Password reuperata con successo! Controlla la tua mail",
    "dottnet.message.activationMailSent": "Mail d'attivazione inviata con successo!",

    "dottnet.error.11": "Username o password errati",
    "dottnet.error.24": "Username o password vuoti",
    "dottnet.error.44": "Id Sito non trovato",
    "dottnet.error.45": "Gentile Utente, ci risulta che hai chiesto la cancellazione da Dottnet, e quindi abbiamo provveduto a disabilitare il tuo account. Per poter accedere contattaci al n. verde 800.014.863 oppure manda una mail a assistenzaextra@dottnet.it Cordiali saluti La redazione Dottnet",
    "dottnet.error.46": "Specializzazione non iscritta al sito convenzionato",
    "dottnet.error.47": "Categoria non iscritta al sito convenzionato",
    "dottnet.error.48": "Utente non iscritto al sito convenzionato",
    "dottnet.error.49": "Consenso Privacy non ancora espresso",
    "dottnet.error.50": "Consenso Marketing non ancora espresso",
    "dottnet.error.51": "Consenso Profilazione non ancora espresso",
    "dottnet.error.52": "Consenso Marketing Terzi non ancora espresso",
    "dottnet.error.53": "Consenso Profilazione Terzi non ancora espresso",
    "dottnet.error.100": "Gentile utente, poiché sta navigando in incognito, non potremo salvare le sue credenziali",

    "dottnet.search.title": "Risultati di ricerca per",
    "dottnet.search.wordlist": "Trovato con:",
    "dottnet.search.containerinfo": "presente nel",
    "dottnet.search.toofewcharacters": "Inserire almeno tre caratteri",

    "dottnet.consent.header": "Teniamo alla vostra privacy",
    "dottnet.consent.body": "Noi e i nostri partner utilizziamo tecnologie come i cookie o il targeting ed elaboriamo dati personali come l'indirizzo IP o le informazioni sul browser per personalizzare gli annunci che visualizziamo. Queste tecnologie possono accedere al vostro dispositivo e aiutarci a mostrarvi annunci più pertinenti e a migliorare la vostra esperienza sul sito web. Utilizziamo queste tecnologie anche per misurare i risultati o per indirizzare meglio i contenuti del nostro sito web. Poiché teniamo alla vostra privacy, con la presente chiediamo il vostro consenso all'utilizzo delle seguenti tecnologie. È possibile modificare/revocare tale consenso in qualsiasi momento facendo clic sul pulsante Impostazioni nell'angolo in basso a sinistra della pagina..",
    "dottnet.consent.privacy_text": "Politica sulla privacy",
    "dottnet.consent.imprint_text": "Chi Siamo",
    "dottnet.consent.privacy_settings_text": "Gestisci preferenze",
    "dottnet.consent.decline_text": "RIFIUTA",
    "dottnet.consent.accept_text": "ACCETTA TUTTI",
    "dottnet.consent.save_text": "SALVA PREFERENZE",
    "dottnet.consent.back_text": "Indietro",
    "dottnet.consent.privacy_settings_title": "Impostazioni sulla privacy",
    "dottnet.consent.privacy_settings_title_text": "Questo menu vi aiuta a selezionare e disattivare i vari cookie, tracker e strumenti di analisi utilizzati su questo sito web.",
    "dottnet.consent.functional_title": "Funzionali",
    "dottnet.consent.functional_description": "Questi cookie ci consentono di analizzare l'utilizzo del sito web per poterne misurare e migliorare le prestazioni.",
    "dottnet.consent.marketing_title": "Marketing",
    "dottnet.consent.marketing_description": "I cookie di marketing sono solitamente utilizzati per mostrarvi pubblicità che rispondono ai vostri interessi. Quando visitate un altro sito web, il cookie del vostro browser viene riconosciuto e vi vengono mostrati annunci selezionati in base alle informazioni memorizzate in questo cookie (art. 6 par. 1 p. 1 a) GDPR).",
    "dottnet.consent.essential_title": "Essenziali",
    "dottnet.consent.essential_description": "Questi cookie sono necessari per le funzioni di base del sito web..",
    "dottnet.consent.cookie_name": "Nome",
    "dottnet.consent.cookie_description": "Descrizione",
    "dottnet.consent.cookie_duration": "Durata",
    "dottnet.consent.right_bottom": "È possibile modificare/revocare tale consenso in qualsiasi momento facendo clic sul pulsante Impostazioni nell'angolo in basso a destra della pagina.",
    "dottnet.consent.left_bottom": "È possibile modificare/revocare tale consenso in qualsiasi momento facendo clic sul pulsante Impostazioni nell'angolo in basso a sinistra della pagina.",
    "dottnet.consent.right_top": "È possibile modificare/revocare tale consenso in qualsiasi momento facendo clic sul pulsante Impostazioni nell'angolo in alto a destra della pagina.",
    "dottnet.consent.left_top": "È possibile modificare/revocare tale consenso in qualsiasi momento facendo clic sul pulsante Impostazioni nell'angolo in alto a sinistra della pagina.",

    "dottnet.consent.functionalCookies.name": "Google Analytics",
    "dottnet.consent.functionalCookies.description": "Google Analytics è un servizio di analisi web offerto da Google che tiene traccia e segnala il traffico del sito web.",
    "dottnet.consent.marketingCookiesGa.name": "Google Analytics",
    "dottnet.consent.marketingCookiesGa.description": "Google Analytics è un servizio di analisi web offerto da Google che tiene traccia e segnala il traffico del sito web.",
    "dottnet.consent.marketingCookiesGa.privacyPolicyUrl": "https://policies.google.com/privacy?hl=it",
    "dottnet.consent.marketingCookiesMeta.name": "Meta",
    "dottnet.consent.marketingCookiesMeta.description": "Meta è un'impresa statunitense che controlla i servizi di rete sociale Facebook e Instagram",
    "dottnet.consent.marketingCookiesMeta.privacyPolicyUrl": " https://www.facebook.com/privacy/policies/cookies/",
    "dottnet.consent.functionalCookies.privacyPolicyUrl": "https://policies.google.com/privacy",
    "dottnet.consent.functionalCookiesGA.description": "Questo cookie viene utilizzato per distinguere gli utenti.",
    "dottnet.consent.functionalCookiesGA.duration": "2 anni",
    "dottnet.consent.functionalCookiesGID.description": "Questo cookie viene utilizzato per distinguere gli utenti.",
    "dottnet.consent.functionalCookiesGID.duration": "24 ore",
    "dottnet.consent.functionalCookiesGAT.description": "Questo cookie viene utilizzato per limitare la frequenza delle richieste.",
    "dottnet.consent.functionalCookiesGAT.duration": "1 minuto",
    "dottnet.consent.functionalCookiesGTAG.description": "Questo cookie viene utilizzato per limitare la frequenza delle richieste.",
    "dottnet.consent.functionalCookiesGTAG.duration": "1 minuto",
    "dottnet.consent.functionalCookiesTOKEN.description": "Questo cookie viene utilizzato per limitare la frequenza delle richieste.",
    "dottnet.consent.functionalCookiesTOKEN.duration": "1 minuto",
    "dottnet.consent.marketingCookiesGaGA.description": "Questo cookie viene utilizzato per distinguere gli utenti.",
    "dottnet.consent.marketingCookiesGaGA.duration": "2 anni",
    "dottnet.consent.essentialCookies.description": "Questo cookie è utilizzato per garantire il corretto funzionamento di dottnet.it",
    "dottnet.consent.essentialCookies.privacyPolicyUrl": "https://www.dottnet.it/privacy",
    "dottnet.consent.thirdpartyconsent.accepted": "Abbiamo registrato il consenso da lei dato all'azienda: ",
    "dottnet.consent.thirdpartyconsent.failed": "Errore durante la registrazione del consenso. Riprovare",
    "dottnet.disiscrizione.single": "Stai disattivando la ricezione della newsletter",
    "dottnet.disiscrizione.allTitle": "Disiscrizione Newsletter",
    "dottnet.disiscrizione.all": "Confermi di voler disiscriverti da tutte le newsletter",
    "dottnet.disiscrizione.dottnet": "Confermi di volerti cancellare da DottNet",
    "dottnet.disiscrizione.dottnetTitle": "Disiscrizione da DottNet",
    "dottnet.disiscrizione.conferma": "Conferma",
    "dottnet.disiscrizione.annulla": "Annulla",
    "dottnet.disiscrizione.allIntention": "Per cancellarti da tutte le Newsletter clicca qui",
    "dottnet.disiscrizione.dottnetIntention": "Per cancellarti da DottNet clicca qui",
    "dottnet.disiscrizione.unknowUser": "Utente sconosciuto",
    "dottnet.disiscrizione.unknowUserDescription": "Per poterti disiscrivere, abbiamo bisogno di sapere chi sei.",
    "dottnet.disiscrizione.login": "Per loggarti, clicca qui.",
    "dottnet.iscrizione.title": "Complimenti, l'iscrizione alla newsletter è avvenuta con successo!",
    "dottnet.iscrizione.unknowUserDescription": "Per poterti iscrivere, abbiamo bisogno di sapere chi sei.",
    "dottnet.iscrizione.remove": "Clicca qui per annullare l'iscrizione.",
    "dottnet.footer.chiSiamo": "Chi siamo",
    "dottnet.footer.redazione": "Redazione",
    "dottnet.footer.contatti": "Contatti",
    "dottnet.footer.seguici": "seguici su",
    "dottnet.footer.numeroVerde": "Numero Verde 800 014 863",
    "dottnet.footer.honCode": "Aderiamo allo ",
    "dottnet.footer.honCode2": "standard HONcode per l'affidabilità dell'informazione medica",
    "dottnet.footer.check": "Verifica qui.",
    "dottnet.footer.condizioni": "Condizioni di utilizzo",
    "dottnet.footer.privacy": "Privacy",
    "dottnet.footer.cancellazione": "Cancellazione",
    "dottnet.footer.company": "Merqurio Editore s.r.l. - Partita IVA: 05877761212 ",

    "dottnet.extra.duration_3": "/ 3 mesi",
    "dottnet.extra.duration_6": "/ 6 mesi",
    "dottnet.extra.duration_9": "/ 9 mesi",
    "dottnet.extra.duration_12": "/ 1 anno",
    "dottnet.extra.duration_24": "/ 2 anni",
    "dottnet.extra.duration_default": " mesi",
    "dottnet.extra.invoice": "Desideri la fattura?",
    "dottnet.extra.invoiceDetail": "Inserire numero di partita IVA e PEC oppure SD.",
    "dottnet.extra.invoiceVat": "Inserisci partita Iva",
    "dottnet.extra.invoicePec": "Inserisci Pec.",
    "dottnet.extra.invoiceSd": "Inserisci SD",
    "dottnet.extra.Vat": "Partita Iva",
    "dottnet.extra.Pec": "Pec",
    "dottnet.extra.Sd": "SD",
    "dottnet.extra.total": "TOTALE:",
    "dottnet.extra.finalTotal": "(TOTALE effettivo):",
    "dottnet.extra.finalTotalCondition": "Il tuo abbonamento scade il ",
    "dottnet.extra.finalTotalCondition2": ". Anzichè ",
    "dottnet.extra.finalTotalCondition3": "€ ti addebiteremo ",
    "dottnet.extra.finalTotalCondition4": "€ per integrare l'abbonamento esistente.",
    "dottnet.extra.terms": "Termini e condizioni",
    "dottnet.extra.condition": "Leggi e approva le Condizioni del servizio. Cliccando su Prosegui dichiari di aver letto e approvato specificamente gli articoli da 1 a 16 delle Condizioni particolari del ",
    "dottnet.extra.condition2": "Servizio",
    "dottnet.extra.prosegui": "Prosegui",
    "dottnet.extra.paga": "Paga",
    "dottnet.extra.coming": "Cooming soon",
    "dottnet.extra.valuta": "€",
    "dottnet.extra.codiceSconto": "Codice Sconto",
    "dottnet.extra.applicaSconto": "Applica",
    "dottnet.extra.personalization": "Personalizza il tuo abbonamento",
    "dottnet.extra.login": "Loggati per scoprire il mondo Dottnet eXtra",
    "dottnet.extra.payment.email": "Email",
    "dottnet.extra.payment.name": "Nome",
    "dottnet.extra.payment.processing": "Elaborazione in corso",
    "dottnet.extra.payment.pay": "Paga",
    "dottnet.extra.sellerFormAnagrafica": "Inserisci Anagrafica",
    "dottnet.extra.sellerFormNome": "Nome Anagrafica",
    "dottnet.extra.sellerFormCognome": "Cognome Anagrafica",
    "dottnet.extra.sellerFormMail": "Mail Anagrafica",
    "dottnet.extra.sellerFormPremium": "Premium Anagrafica",
    "dottnet.extra.sellerFormDataInizio": "Data Inizio Abbonamento",
    "dottnet.extra.sellerFormDataFine": "Data Fine Abbonamento",
    "dottnet.extra.sellerFormCarica": "Carica Anagrafica",
    "dottnet.extra.sellerAbbonato": "Abbonato Premium",
    "dottnet.extra.sellerNonAbbonato": "NON Abbonato Premium",
    "dottnet.extra.selectCoupon": "Seleziona Coupon",
    "dottnet.extra.createCoupon": "GENERA COUPON SCONTO",
    "dottnet.extra.deleteSubscriptionAll": "Disdici tutto l'abbonamento alla scadenza",
    "dottnet.extra.deleteSubscription": "Disdici il pacchetto alla scadenza",
    "dottnet.extra.activateSubscription": "Riattiva l'abbonamento alla scadenza",
    "dottnet.extra.reserved": "Articolo riservato agli abbonati di Dottnet eXtra",
    "dottnet.extra.base": "<h1> DottNet eXtra</h1> <p>Lo strumento unico che facilita e migliora il tuo aggiornamento e la tua professione.</p><p>Abbiamo voluto creare qualcosa di completamente nuovo, ma solo dopo aver ascoltato i suggerimenti di migliaia di colleghi medici su tutto il territorio Nazionale.</p><p> Così nasce questo spazio, <strong> riservato a chi vuole trovare solo contenuti ad altissimo valore scientifico e soluzioni professionali al massimo livello.</strong>Il tutto con la piena ed assoluta libertà di scelta senza alcuna imposizione di prodotto o servizio.</p><p><strong>Con DottNet eXtra sei tu il vero protagonista.</strong> Scegli in totale autonomia solo ciò che vuoi, quando vuoi. Così anche il costo della tua iscrizione lo decidi tu. Soluzioni uniche in tutti gli ambiti:</p><ul><li><strong>Articoli scientifici completi</strong> ad altissimo valore aggiunto</li><li><strong>Adeguamento Privacy del Medico</strong> secondo <strong>GDPR</strong></li><li><strong>Consulenza specializzata in ambito previdenziale</strong></li><li><strong>Credito privilegiato</strong> con i finanziamenti unici di Club Medici</li> <li> <strong>Tutela legale a massimale illimitato</strong> per anno e per sinistro (con la scelta del legale nel circuito specializzato Legal Service) </li><li><strong>Consulenza e condizioni assicurative esclusive</strong> grazie al circuito MedicoProtetto.</li></ul><p> Scopri questo e molto altro nello <strong>spazio pensato per te.</strong> Scegli ciò che ti interessa ed entra subito in DottNet eXtra.</p>",
    "dottnet.extra.entra": "Entra nel mondo",
    "dottnet.extra.dtnExtra": "DottNet eXtra",
    "dottnet.extra.support": "Hai bisogno di supporto?",
    "dottnet.extra.call": "Chiama un nostro operatore al numero:",
    "dottnet.extra.freenumber": "800.072.636",
    "dottnet.extra.codutente": "Cod.utente",
    "dottnet.extra.totalEcm": "Punti ECM totali:",
    "dottnet.extra.availabelEcm": "Punti ECM disponibili:",
    "dottnet.extra.subscriptionFrom": "Abbonamento attivo dal",
    "dottnet.extra.subscriptionTo": "Scadenza abbonamento",
    "dottnet.extra.mycourses": "I miei corsi",
    "dottnet.extra.extraArticle": "Articoli Extra",
    "dottnet.extra.subscriptionOk": "Abbonamento attivato con successo",
    "dottnet.extra.subscriptionKo": "Qualcosa è andato storto durante il processo.</br> Contattare l'assistenza. Nulla è stato addebitato",
    "dottnet.extra.error": "Qualcosa è andato storto.</br> Contattare l'assistenza.",
    "dottnet.extra.invalidStatus": "Qualcosa è andato storto.Stato di conferma invalido.</br> Contattare l'assistenza. Payment Status: ",
    "dottnet.extra.disdetta": "<h1> DottNet eXtra</h1> <p>Disdetta avvenuta con successo!</p>",
    "dottnet.extra.welcome": "<h1> DottNet eXtra</h1> <p>Abbonamento attivato correttamente.</p><p>Benvenuto in <strong> eXtra.</strong></p>",
    "dottnet.extra.deactivated": "Pacchetto disattivato alla scadenza",
    "dottnet.extra.subscriptionExists": "Attenzione. Risulti già sottoscritto ai piani scelti.",
    "dottnet.shared.error": "Qualcosa è andato storto",
    "dottnet.userform.intro": "Registrandoti a Dottnet accetti le nostre",
    "dottnet.userform.condition": "Condizioni",
    "dottnet.userform.intro2": "Inoltre confermi di aver letto la nostra",
    "dottnet.userform.privacy": "Informativa",
    "dottnet.userform.intro3": "sull'utilizzo dei dati, compresa la sezione dedicata all'uso dei cookie.",
    "dottnet.notfound.h2": "Oops! Qualcosa è andato storto ",
    "dottnet.notfound.p": "La pagina che stai cercando potrebbe essere stata rimossa o non essere al momento disponibile.",
    "dottnet.notfound.a": "Ritorna alla Home",
    "dottnet.label.read": "Leggi",
    "dottnet.label.watch": "Guarda",
    "dottnet.profile.reserved": "Gentile utente, l'area profilo è riservata. Effettuare l'accesso",
    "dottnet.pdf.alertDownload": "Gentile utente il file non è scaricabile. L'uso è per sola lettura.",
    "dottnet.pdf.alertPrint": "Gentile utente il file non è stampabile. L'uso è per sola lettura.",
    "dottnet.errorcode.78": "Pagamento rifiutato. Fondi insufficienti sulla carta.",
    "dottnet.errorcode.79": "Pagamento rifiutato. La carta risulta smarrita.",
    "dottnet.errorcode.80": "Pagamento rifiutato. La carta risulta rubata.",
    "dottnet.errorcode.81": "Pagamento rifiutato. Carta scaduta.",
    "dottnet.errorcode.82": "Pagamento rifiutato. Codice CVC non corretto.",
    "dottnet.errorcode.83": "Pagamento rifiutato. Numero carta non corretto.",

    "dottnet.errorcode.85": "Errore durante l'iscrizione al corso. Fallito salvataggio iscrizione. Contattare l'assistenza.",
    "dottnet.errorcode.86": "Errore durante l'iscrizione al corso. Fallito salvataggio consensi. Contattare l'assistenza.",
    "dottnet.errorcode.87": "Errore durante l'iscrizione al corso. Fallito salvataggio dati ecm. Contattare l'assistenza.",

    "dottnet.shared.affermativo": "Sì",
    "dottnet.shared.negativo": "No",
    "dottnet.enrollement.ecm": "Rilascio crediti",
    "dottnet.enrollement.enroll": "Reclutato*",
    "dottnet.enrollement.registration": "Iscriviti",
    "dottnet.enrollement.enrollLable": "*Si considera reclutato il professionista sanitario che, per la partecipazione ad eventi formativi, beneficia di vantaggi economici e non economici, diretti ed indiretti, da parte di imprese commerciali operanti in ambito sanitario",
    "dottnet.enrollement.registrationLable": "Iscrizione al corso",
    "dottnet.enrollement.enrollSuccess": "Iscrizione al corso avvenuta con successo.</br>Controlli la mail per i dettagli.",
    "dottnet.enrollement.enrolled": "Gentile utente, risulti già iscritto a questo corso.</br> Controlla la tua casella e-mail per la conferma di iscrizione.</br> Puoi richiedere l'invio di una nuova mail cliccando sul bottone dedicato.",
    "dottnet.poll.votes": "voti",
    "dottnet.poll.expiry": "giorni rimanenti",
    "dottnet.poll.undo": "Annulla",
    "dottnet.poll.closed": "Sondaggio chiuso",
    "dottnet.repblog.noinfo": "Siamo spiacenti, non ci risultano informatori assegnati alla tua area.",
    "dottnet.repblog.welcome1": "Benvenuto nell'area dedicata alla videocall,",
    "dottnet.repblog.welcome2": "per entrare in relazione diretta con un Informatore",
    "dottnet.repblog.info1": "Per maggiori informazioni,",
    "dottnet.repblog.info2": "può rivolgersi al numero verde:",
    "dottnet.repblog.info3": "800 014 863",
    "dottnet.meta.website.description": "DottNet è un portale medico con news, studi e approfondimenti per professionisti della salute.",
    "dottnet.meta.organization.description": "DottNet è un portale medico con news, studi, webinar e approfondimenti per medici, farmacisti e professionisti sanitari.",
    "dottnet.meta.organization.legalName": "Merqurio Editore s.r.l.",
    "dottnet.meta.organization.streetAddress": "Corso Umberto I, 23",
    "dottnet.meta.organization.addressLocality": "Napoli",
    "dottnet.meta.organization.postalCode": "80138",
    "dottnet.meta.organization.addressCountry": "IT",
    "dottnet.meta.contacts.telephone": "800.014.863",
    "dottnet.meta.contacts.email": "redazione@merqurio.it",
    "dottnet.meta.organization.department.name": "Redazione",
    "dottnet.label.evidenza": "In Evidenza",
    "dottnet.label.account.signign": "Non hai un account?",
    "dottnet.placeholder.date": "DD/MM/AAAA",
    "dottnet.countdown.days": "Giorni",
    "dottnet.countdown.hours": "Ore",
    "dottnet.countdown.minutes": "Minuti",
    "dottnet.countdown.seconds": "Secondi",
    "dottnet.dropdownMidgetMenu.defaultTitle": "Menu",
    "dottnet.pec.title": "PEC DottNet",
    "dottnet.pec.label": "Gentile utente la sua pec non è configurata"

}
